export const potentialListHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Date",
		value: "updated_at",
		valueFilter: 'filter_updated_at',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
		dense: true,
	},
	{
		settings: true,
		text: "MC#",
		value: "mc",
		valueFilter: "filter_mc",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Truck q-ty",
		value: "truck_quantity",
		valueFilter: "filter_truck_quantity",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Carrier name",
		value: "carrier",
		valueFilter: "filter_carrier",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Contact name",
		value: "contact",
		valueFilter: "filter_contact",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Phone",
		value: "phone",
		valueFilter: "filter_phone",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Email",
		value: "email",
		valueFilter: "filter_email",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Comment",
		value: "comment",
		valueFilter: "filter_comment",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true,
		counter: true,
		align: 'center'
	},
	{
		settings: true,
		sticky: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];
